import type { ReactNode } from 'react'

interface ExternalLinkProps {
	children: ReactNode
	className?: string
	href: string
	rel?: string
	target?: string
}

export function ExternalLink({
	children,
	className,
	href,
	rel = 'noopener noreferrer',
	target = '_blank',
}: Readonly<ExternalLinkProps>) {
	return (
		// biome-ignore lint/correctness/noRestrictedElements: This IS the ExternalLink component
		<a
			className={className}
			data-testid={'external-link'}
			href={href}
			rel={rel}
			target={target}>
			{children}
		</a>
	)
}
